/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  Reducer for Walkscore
 */

import type { WalkscoreModule } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import { RECEIVE_WALKSCORE } from '../constants/index'
import type { ActionTypes } from '../types'

export const walkscoreReducer = combineReducers<WalkscoreModule, ActionTypes>({
  data: handleActions<WalkscoreModule['data'], ActionTypes>(
    {
      [RECEIVE_WALKSCORE]: (state, { payload }) => {
        return payload
      },
    },
    null
  ),
})
